module.exports = __webpack_public_path__ + "static/img/hdb.be6b8df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/hdb.jpg
// module id = FwIa
// module chunks = 0